import Create from './Create';
import List from './List';
import Update from './Update';
import Show from './Show';

export { Create, List, Update, Show }



// WEBPACK FOOTER //
// ./src/components/clientproduct/index.js